import { toast } from "react-hot-toast";

// ---------------------------------------------------------------------------
// Centralized alert utilities — backed by react-hot-toast.
// A single <Toaster> must be mounted once in App.js.
// ---------------------------------------------------------------------------

/** Extract a readable message from an Axios error, with an optional fallback. */
export const getApiErrorMessage = (error, fallbackMessage = "Gabim i panjohur.") => {
  if (error?.response?.data?.errorMessage) {
    return `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`;
  }
  if (typeof error?.response?.data === "string" && error.response.data.trim() !== "") {
    return error.response.data;
  }
  if (error?.message) {
    return `Gabim: ${error.message}`;
  }
  return fallbackMessage;
};

/** Green toast — use for create / insert operations. */
export const handleSuccess = (text) => {
  toast.success(text, {
    duration: 3000,
    icon: "✅",
    style: {
      background: "#16a34a",
      color: "#ffffff",
      border: "1px solid #15803d",
    },
  });
};



/** Green toast — use for successful delete operations. */
export const deleteAlert = (text) => {
  toast(text, {
    duration: 3500,
    icon: "🗑️",
    style: {
      background: "#f97316",
      color: "#ffffff",
      border: "1px solid #ea580c",
    },
  });
};

/** Red toast — use for all error conditions. */
export const errorAlert = (text) => {
  toast.error(text, { duration: 5000 });
};

/** Green toast — use for update / edit operations. */
export const updateAlert = (text) => {
  toast(text, {
    duration: 3000,
    icon: "✏️",
    style: {
      background: "#2563eb",
      color: "#ffffff",
      border: "1px solid #1d4ed8",
    },
  });
};

/** Neutral toast — use for informational messages. */
export const infoAlert = (text) => {
  toast(text, { duration: 4000 });
};

/** Warning toast — use for fiscal year changes and other caution messages. */
export const fiscalYearAlert = (text) => {
  toast(text, {
    duration: 5000,
    icon: "⚠️",
    style: { background: "#f59e0b", color: "#fff" },
  });
};


